export const siteOverviewData = [
    {
        id: 1,
        title: "Bounce Rate",
        average_user: 78.65,
        todays_user: 22.85,
        prev_user: 20.49,
        colors: ["#64748a"]
    },

    {
        id: 3,
        title: "Page Views",
        average_user: 86.37,
        todays_user: 34.25,
        prev_user: 36.47,
        colors: ["#3454d1"]
    },
    {
        id: 4,
        title: "Site Impressions",
        average_user: 67.53,
        todays_user: 42.72,
        prev_user: 43.67,
        colors: ["#e49e3d"]
    },
    {
        id: 5,
        title: "Conversions Rate",
        average_user: 32.53,
        todays_user: 35.47,
        prev_user: 22.34,
        colors: ["#25b865"]
    },

]